/**
 * API root for axios/fetch.
 * Local: http://localhost:5001/api
 * Hosted Pathmate: https://apiaipath.snsihub.ai/api (no same-origin /api proxy)
 */
const PROD_API = "https://apiaipath.snsihub.ai/api";
const LOCAL_API = "http://localhost:5001/api";

export function getApiBase() {
  const fromEnv = String(process.env.REACT_APP_API_URL || "")
    .trim()
    .replace(/\/+$/, "");
  if (fromEnv && fromEnv !== "/api") return fromEnv;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return LOCAL_API;
    }
  }

  return PROD_API;
}

export const API_BASE = getApiBase();
